// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article__embed .fb-video{width:100%;height:0;background-color:#fff;position:relative;overflow:hidden}.article__embed .fb-video .fb-video-iframe{width:100%!important;height:100%!important;position:absolute;top:0;left:0}@media (max-width:576px){.article__embed .youtube-short{padding-bottom:180%!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
